import { render, staticRenderFns, recyclableRender, components } from "./write-off-a.vue?vue&type=template&id=02cf6fcc&scoped=true&"
var renderjs
import script from "./write-off-a.vue?vue&type=script&lang=js&"
export * from "./write-off-a.vue?vue&type=script&lang=js&"
import style0 from "./write-off-a.vue?vue&type=style&index=0&lang=css&"
import style1 from "./write-off-a.vue?vue&type=style&index=1&id=02cf6fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf6fcc",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/write-off-a/write-off-a.vue"
export default component.exports